<template>
    <div class="popup popup-container" :class="[isShow ? 'popup-show': '']" :style="popupStyle" @transitionend="onTransitionEnd" >
        <div class="shadow" @click="shadowHide" :style="shadowStyles" ></div>
        <div class="popup-content t-c" :class="animation || 'none'" >
            <slot></slot>
        </div>
        <slot name="second" ></slot>
    </div>
</template>

<script>
import Vue from 'vue'
export default {
    props: {
        animation: 'fade' | 'scale' | 'none',
        shadowClose: Boolean,
        shadowOpacity: Number,
        zIndex: Number
    },
    data() {
        return {
            isShow: false
        }
    },
    computed: {
        shadowStyles() { return `background-color: rgba(0, 0, 0, ${this.shadowOpacity || 0.4});` },
        popupStyle() { return this.show && this.zIndex ? `z-index: ${this.zIndex};`: '' }
    },
    methods: {
        show() { this.isShow = true },
        hide() { this.isShow = false, this.$emit("onhide") },
        shadowHide() { this.shadowClose && this.hide() },
        onTransitionEnd() { this.$emit("ontransitionend") }
    }
}
</script>

<style lang="scss" scoped >
.popup, .popup .shadow {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    transition: z-index linear .3s, opacity linear .3s;
    -webkit-transition: z-index linear .3s, opacity linear .3s;
}

.popup {
    z-index: -1;

    .shadow {
        opacity: 0;
    }

    .popup-content {
        position: absolute;
        display: inline-block;
        width: 100%;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transition: top linear .3s .1s, opacity linear .3s .1s, transform linear .3s .1s;
        -webkit-transition: top linear .3s .1s, opacity linear .3s .1s, -webkit-transform linear .3s .1s;
    }

    .fade {
        top: calc(50% + 1rem);
        opacity: 0;
    }

    .scale {
        transform: translate(-50%, -50%) scale(0);
        -webkit-transform: translate(-50%, -50%) scale(0);
    }
}

.popup-show {
    z-index: 10;

    .shadow {
        opacity: 1;
    }

    .popup-content {

    }

    .fade {
        top: 50%;
        opacity: 1;
    }

    .scale {
        transform: translate(-50%, -50%) scale(1);
        -webkit-transform: translate(-50%, -50%) scale(1);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Popup.vue